import React from 'react';

import { SectionFeaturedShelfProps } from './types/SectionArticleShelves.types';
import { white, gallery } from './styles/SectionShelf.styles';
import { ArticleCard } from '../../Elements/ArticleCard';
import {
  FeaturedShelfArticleContainer,
  FeaturedShelfHeading,
  ShelfFeaturedArticleWrapper,
} from './styles/SectionFeaturedShelf.styles';

const SectionFeaturedShelf = ({
  displayName,
  articles,
  backgroundColor,
  readingTimeMinuteLabel,
  displaySaveIcon,
  saveLabelText,
  seoTitle,
  articleIndexSlug,
  handleSaveClick,
}: SectionFeaturedShelfProps) => {
  const backgroundStyle = backgroundColor === 'white' ? white : gallery;

  const theArticles = articles.map(article => {
    return (
      <ShelfFeaturedArticleWrapper
        className="page-article-container"
        key={article.id}
      >
        <ArticleCard
          isAnimated={true}
          isFeatured={true}
          key={article.id}
          indexSlug={articleIndexSlug}
          data={article}
          backgroundColor={'white'}
          seoTitle={seoTitle}
          readingTimeMinuteLabel={readingTimeMinuteLabel}
          displaySaveIcon={displaySaveIcon}
          saveLabelText={saveLabelText}
          handleSaveClick={handleSaveClick}
        />
      </ShelfFeaturedArticleWrapper>
    );
  });

  return (
    <div css={backgroundStyle}>
      <div className="spring custom-spring">
        <FeaturedShelfHeading>
          <h3>{displayName}</h3>
        </FeaturedShelfHeading>
        <FeaturedShelfArticleContainer
          isSingle={articles.length > 1 ? false : true}
        >
          {theArticles}
        </FeaturedShelfArticleContainer>
      </div>
    </div>
  );
};

export default SectionFeaturedShelf;
